export const SHOW_STATS_CONFIG_PATH = "liveScanner.liveComponents.playerScoreCard.showStatisticsOnPlayerScorecard";
export const SHOW_R2H_CONFIG_PATH = "liveScanner.liveComponents.playerScoreCard.showNTTR2HClipTag";
export const ROOT_CSS_CLASS = "live-player-scores";
export const CELL_DIV_HOLE_ROUND_PATH = "attributes.cell-hole-round.value";
export const CELL_DIV_HOLE_ID_PATH = "attributes.cell-hole-id.value";
export const R2H_EVENT_CATEGORY = "Scorecard Route to Hole";
export const R2H_EVENT_DEFAULT_LABEL = "Route To Hole";